



























import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'


import marked from 'marked'
import highlightjs from 'highlight.js'

// import { marked } from '../../../../../provider/service/marked/constants'
// import { highlightjs } from '../../../../../provider/service/highlightjs/constants'


// import readmeFileString from '../../../../../../../../../../../README.md'
import readmeFileString from '../../../../../../../../README.md'


const readmeHtmlString = marked(readmeFileString)

@Component
class AboutThisProject extends Vue {
  projectName: string = projectVariables.projectName
  readmeHtmlString: string = readmeHtmlString

  showReadMeDocumentContent: boolean = false

  mounted () {
    // this.updateReadmeDocumentObject()
  }

  @Watch('showReadMeDocumentContent') async updateReadmeDocumentObject () {
    if (!this.showReadMeDocumentContent) {
      return
    }

    await new Promise((resolve) => setTimeout(resolve, 0))

    this.updateReadmeDocumentCodeElementList()
    this.updateReadmeDocumentTableElementList()
  }

  updateReadmeDocumentCodeElementList () {
    const readmeDocumentObject = this.$refs['readmeDocumentObject'] as HTMLElement

    if (!readmeDocumentObject) {
      return
    }

    readmeDocumentObject.querySelectorAll('pre code').forEach((htmlElement) => {
      highlightjs.highlightBlock(htmlElement as HTMLElement)
    })
  }

  updateReadmeDocumentTableElementList () {
    const readmeDocumentObject = this.$refs['readmeDocumentObject'] as HTMLElement

    if (!readmeDocumentObject) {
      return
    }

    readmeDocumentObject.querySelectorAll('table').forEach((htmlTableElement) => {
      const tableContainer = document.createElement('div')
      tableContainer.className = 'table-container'
      if (!htmlTableElement.parentNode) { return }
      htmlTableElement.parentNode.insertBefore(tableContainer, htmlTableElement)
      tableContainer.appendChild(htmlTableElement)
    })
  }
}

export default AboutThisProject
